import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=196135df"
import script from "./SendMessage.vue?vue&type=script&lang=js"
export * from "./SendMessage.vue?vue&type=script&lang=js"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./SendMessage.vue?vue&type=style&index=0&id=196135df&lang=css")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('196135df')) {
      api.createRecord('196135df', component.options)
    } else {
      api.reload('196135df', component.options)
    }
    module.hot.accept("./SendMessage.vue?vue&type=template&id=196135df", function () {
      api.rerender('196135df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SendMessage.vue"
export default component.exports